/**
 * Marker mappings for KID preset table components; each component filters and
 * injects its own subset of `GET /kid/marker/type/...` values.
 */

/** FIG marker consumed by the SRI chart block. */
export const SRI_MARKER = {
  markerType: 'FIG',
  placeholder: 'sri',
} as const;

/**
 * COST markers consumed by the Composition of Costs table.
 * Each maps to the percentage column for its cost row.
 */
export const COMPOSITION_OF_COSTS_MARKERS = [
  { category: 'One-Off Costs', costType: 'Entry costs', markerType: 'COST', placeholder: 'entry_cost' },
  { category: '', costType: 'Exit costs', markerType: 'COST', placeholder: 'exit_cost' },
  { category: 'Ongoing Costs', costType: 'Transaction costs', markerType: 'COST', placeholder: 'transaction_cost' },
  {
    category: '',
    costType: 'Management fees and other administrative and operating costs',
    markerType: 'COST',
    placeholder: 'ongoing_cost',
  },
  { category: 'Incidental Costs', costType: 'Performance fees', markerType: 'COST', placeholder: 'performance_fee' },
] as const;

/**
 * FIG markers for the Costs Over Time table (total costs + RIY per period).
 * FUND:fund_currency is used to build the investment scenario header.
 */
export const COSTS_OVER_TIME_MARKERS = {
  fundCurrency: { markerType: 'FUND', placeholder: 'fund_currency' },
  holdingPeriod: { markerType: 'FUND', placeholder: 'holding_period' },
  totalCostOneYear: { markerType: 'FIG', placeholder: 'total_cost_one_year' },
  totalCostHoldingPeriod: { markerType: 'FIG', placeholder: 'total_cost_recommended_holding_period' },
  riyOneYear: { markerType: 'FIG', placeholder: 'riy_one_year' },
  riyHoldingPeriod: { markerType: 'FIG', placeholder: 'riy_recommended_holding_period' },
} as const;

/** FIG scenario markers for the Performance Scenarios table. */
export const PERFORMANCE_SCENARIO_MARKERS = [
  {
    label: 'Stress',
    amountOneYear: 'stressed_amount_back_one_year_period',
    returnOneYear: 'stressed_return_back_one_year_period',
    amountHolding: 'stressed_amount_back_recommended_holding_period',
    returnHolding: 'stressed_return_back_recommended_holding_period',
  },
  {
    label: 'Unfavourable',
    amountOneYear: 'unfavourable_amount_back_one_year_period',
    returnOneYear: 'unfavourable_return_back_one_year_period',
    amountHolding: 'unfavourable_amount_back_recommended_holding_period',
    returnHolding: 'unfavourable_return_back_recommended_holding_period',
  },
  {
    label: 'Moderate',
    amountOneYear: 'moderate_amount_back_one_year_period',
    returnOneYear: 'moderate_return_back_one_year_period',
    amountHolding: 'moderate_amount_back_recommended_holding_period',
    returnHolding: 'moderate_return_back_recommended_holding_period',
  },
  {
    label: 'Favourable',
    amountOneYear: 'favourable_amount_back_one_year_period',
    returnOneYear: 'favourable_return_back_one_year_period',
    amountHolding: 'favourable_amount_back_recommended_holding_period',
    returnHolding: 'favourable_return_back_recommended_holding_period',
  },
] as const;
